import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'styles/main.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react';

const root = createRoot(document.getElementById('root'));

root.render(
    /**
     * NOTE:
     * Known issue in react
     * useEffect is running twice in development mode when
     * we have StrictMode. Disabling till we do to cloud.
     */
    // <React.StrictMode>
    <BrowserRouter>
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </BrowserRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
